import AbstractOfferSlideTransform from '@app/transforms/slides/AbstractOfferSlideTransform';
import SeasonType from '@app/types/base/SeasonType';
import IPriceItem from '@app/types/data/base/IPriceItem';
import ISeasonWithPrice from '@app/types/data/base/ISeasonWithPrice';
import ISlideMaster from '@app/types/presentations/master/ISlideMaster';
import IPresentationSettings from '@app/types/presentations/presentation/IPresentationSettings';
import { Entry } from 'contentful';
import ITravelPassSlideData from '../../types/data/slides/ITravelPassSlideData';
import ITravelPassPriceMatrixItem from '../../types/data/slides/present/ITravelPassPriceMatrixItem';

/**
 * Transform for 015-TravelPassSlide
 */
export default class TravelPassSlideTransform extends AbstractOfferSlideTransform {
	public viewComponent: string = 'TravelPassSlide';

	public async transform(
		slide: ISlideMaster,
		presentationSettings: IPresentationSettings
	): Promise<ITravelPassSlideData> {
		const data: ITravelPassSlideData = {
			...(await super.transform(slide, presentationSettings)),
			connection: this.parseConnection(slide.fields.connectingTicket.fields.connection),
			priceMatrix: slide.fields.prices.map(
				(priceEntry: Entry<any>): ITravelPassPriceMatrixItem => ({
					svgGroupId: priceEntry.fields.svgGroupId as ITravelPassPriceMatrixItem['svgGroupId'],
					dayCount: priceEntry.fields.numberOfDays as ITravelPassPriceMatrixItem['dayCount'],
					b2c: {
						adult: priceEntry.fields.b2cAdult as IPriceItem['adult'],
						adultDiscounted: priceEntry.fields.b2cAdultDiscounted as IPriceItem['adultDiscounted'],
						child: priceEntry.fields.b2cChild as IPriceItem['child'],
						childDiscounted: priceEntry.fields.b2cChildDiscounted as IPriceItem['childDiscounted']
					},
					b2b: {
						adult: priceEntry.fields.b2bAdult as IPriceItem['adult'],
						adultDiscounted: priceEntry.fields.b2bAdultDiscounted as IPriceItem['adultDiscounted'],
						child: priceEntry.fields.b2bChild as IPriceItem['child'],
						childDiscounted: priceEntry.fields.b2bChildDiscounted as IPriceItem['childDiscounted']
					}
				})
			)
		};

		// Travel pass has a "Connecting Ticket Season" which has a price, extra parsing needed
		data.connection.seasons = slide.fields.connectingTicket.fields.seasons.map(
			(seasonEntry: Entry<any>): ISeasonWithPrice => ({
				type: seasonEntry.fields.type as SeasonType,
				title: seasonEntry.fields.title as string,
				startDate: seasonEntry.fields.startDate as string,
				endDate: seasonEntry.fields.endDate as string,
				price: seasonEntry.fields.price as number
			})
		);

		return data;
	}
}
